import { render } from "./VideoPreview.vue?vue&type=template&id=b67a68f0&scoped=true"
import script from "./VideoPreview.vue?vue&type=script&lang=js"
export * from "./VideoPreview.vue?vue&type=script&lang=js"

import "./VideoPreview.vue?vue&type=style&index=0&id=b67a68f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b67a68f0"

export default script